module.exports = __webpack_public_path__ + "img/star1.22ebe0c8.png";